import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {ImagePicker} from '@pulsoid-private/widgets-lib';
import ColorPicker from './ColorPicker';
import {Action} from '../../../system/buttons';
import '../../../App.css';
import {FontManager} from './FontManager';

const DEFAULT_IMAGE_CONFIG = {
  size: 60,
  color: '#000000',
  withAnimation: true,
};

export class PrideBpmBasicEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.configuration,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate({
        alignment: this.state.alignment,
        font: this.state.font,
        backgroundColor: this.state.backgroundColor,
        ranges: this.state.ranges,
        fontUrl: this.state.fontUrl,
        image: this.state.image,
      });
    }
  }

  render() {
    return (
      <>
        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Color
          </Form.Label>
          <Col sm="3">
            <ColorPicker
              color={this.state.ranges[0].color}
              onChangeComplete={(color) => {
                this.setState({
                  ranges: [
                    {
                      from: 0,
                      to: 1000,
                      color,
                    },
                  ],
                });
              }}
            />
          </Col>
        </Form.Group>

        <Row>&nbsp;</Row>

        <FontManager
          font={this.state.font}
          fontUrl={this.state.fontUrl}
          onChange={(font) => this.setState({font})}
        />

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Alignment
          </Form.Label>
          <Col sm="3">
            <Form.Control
              as="select"
              value={this.state.alignment}
              onChange={(e) => this.setState({alignment: e.target.value})}
            >
              <option key={1}>left</option>
              <option key={2}>center</option>
              <option key={3}>right</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Widget Icon
          </Form.Label>
          <Col sm="3">
            <ImagePicker
              preset="pride"
              selectedItem={this.state.image?.type || null}
              onSelect={(type) =>
                this.setState({
                  image: type
                    ? {...DEFAULT_IMAGE_CONFIG, ...this.state.image, type}
                    : null,
                })
              }
            />
          </Col>
        </Form.Group>

        {this.state.image && this.state.image?.type !== null ? (
          <>
            <Form.Group as={Row}>
              <Form.Label column sm="2">
                {/* Widget Icon settings */}
              </Form.Label>

              <Form.Group as={Col} sm="3">
                <Form.Label htmlFor="image.size">Icon Size</Form.Label>
                <Form.Control
                  style={{height: 38}}
                  id="image.size"
                  type="range"
                  value={
                    ('size' in this.state.image
                      ? this.state.image.size
                      : DEFAULT_IMAGE_CONFIG.size) / 1.3
                  }
                  onChange={(e) =>
                    this.setState({
                      image: {
                        ...this.state.image,
                        size: Number(e.target.value) * 1.3,
                      },
                    })
                  }
                />
              </Form.Group>
              <Form.Group as={Col} sm="3">
                <Form.Label htmlFor="image.withAnimation">
                  Icon Animation
                </Form.Label>
                <Form.Switch
                  style={{marginTop: 7}}
                  id="image.withAnimation"
                  defaultChecked={
                    'withAnimation' in this.state.image
                      ? this.state.image.withAnimation
                      : DEFAULT_IMAGE_CONFIG.withAnimation
                  }
                  onChange={(e) =>
                    this.setState({
                      image: {
                        ...this.state.image,
                        withAnimation: e.target.checked,
                      },
                    })
                  }
                />
              </Form.Group>
            </Form.Group>
          </>
        ) : null}

        <Action
          onClick={() =>
            this.props.onSave({
              alignment: this.state.alignment,
              font: this.state.font,
              backgroundColor: this.state.backgroundColor,
              ranges: this.state.ranges,
              fontUrl: this.state.fontUrl,
              image: this.state.image,
            })
          }
        >
          Save settings
        </Action>
      </>
    );
  }
}
